<template>
  <div class="flex flex-col h-full">
    <div class="flex-1 flex flex-col items-center p-6">
      <profile-editor v-model="profile" :isNew="false"/>
    </div>
    <div class="flex justify-end p-4">
      <button class="link mr-2" @click="$bvueUi.modal.close()">{{ $t('cancelar') }}</button>
      <button :class="['btn', 'btn-primary', profileLoading]" @click="storeProfile">{{ $t('guardar') }}</button>
    </div> 
  </div>
</template>

<script>
import firebase from '@/firebase'
import firebaseApp from 'firebase/app'
import ProfileEditor from '@/components/ProfileEditor'

export default {
  name: 'ProfileEditorModal',
  components: {
    ProfileEditor
  },
  props: {
    modalData: {
      type: Object,
      required: true
    },
  },
  mounted() {
    this.$ga.page('/Editar Perfil');
  },
  data() {
    return {
      profile: this.modalData,
      profileLoading: false
    }
  },
  methods: {
    async storeProfile() {
      if (this.profile.name.length == 0 || this.profile.country.length == 0) {
        this.$dialogs.alert('Debes rellenar todos los campos', {title: 'Error', okLabel: ''} )
        return 
      }

      this.profileLoading = ['loading', 'disabled']
      const stored = await this.$store.dispatch('auth/setProfile', this.profile)
      this.profileLoading = []
      if (!stored) {
        console.log('error: Profile not stored')
        this.$dialogs.alert('El usuario no se ha podido guardar', {title: 'Error', okLabel: ''} )
      } else {
        this.$bvueUi.modal.close()
      }

      if (this.profile.password && this.profile.newemail) {
        const credential = firebaseApp.auth.EmailAuthProvider.credential(
          this.profile.email,
          this.profile.password
        )
        const user = firebase.auth.currentUser
        user.reauthenticateWithCredential(credential)
        .then(() => {
          return user.updateEmail(this.profile.newemail)
        })
        .then(() => {
          this.$dialogs.alert('Es posible que debas volver a cargar el sitio para apreciar los cambios', {title: 'Datos almacenados', okLabel: 'Ok'} )
        })
        .catch(() => {
          this.$dialogs.alert('Algo ha salido mal, vuelve a intentarlo.', {title: 'Contraseña Incorrecta', okLabel: 'Ok'} )
        })
      }
    }
  },
  created() {
    console.log('this.modalData: ', this.modalData)
    console.log('this.profile: ', this.profile)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ProfileEditorModal.vue